import { Injectable } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { CookieKeys, CookieOptions } from 'src/app/types';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private CookieService: SsrCookieService) {}
  set(name: CookieKeys, value: string, options?: CookieOptions) {
    this.CookieService.set(name, value, {
      path: '/',
      ...options,
    });
  }

  get(name: CookieKeys) {
    return this.CookieService.get(name);
  }

  delete(name: CookieKeys, path?: string) {
    this.CookieService.delete(name, path);
  }
}
